// Spanish (Latin American, informal "tú") copy for advice-category landing pages.
// Mirrors lib/adviceCategories.js exactly on slug/href/ids; only visible text is translated.
export const ADVICE_CATEGORIES_ES = [
  {
    slug: "life-coaching",
    title: "Consejo de life coaching en línea",
    seoTitle: "Consejo de life coaching en línea | Llamadas al instante con coaches certificados",
    description:
      "Recibe consejo de life coaching en línea con llamadas de audio o video al instante con coaches verificados en Camyvera. Trabaja claridad, metas, confianza y próximos pasos, rápido.",
    hero:
      "Habla con un life coach cuando el tiempo importa. Recibe orientación rápida sobre claridad, confianza, hábitos y decisiones personales sin esperar semanas por una cita.",
    keywords:
      "consejo de life coaching en línea, hablar con un life coach, life coach al instante, life coaching por minuto, llamada con life coach",
    primaryLinks: [
      { href: "/talk-to-life-coach", label: "Habla con un life coach" },
      { href: "/instant-coaching-call", label: "Llamada de coaching al instante" },
      { href: "/blog/how-to-talk-to-experts-online", label: "Lee la guía de consejo de expertos" },
    ],
    faqs: [
      {
        q: "¿Puedo hablar con un life coach de inmediato?",
        a: "Sí. Camyvera está diseñada para llamadas de coaching al instante, así que si un coach está en línea puedes conectarte de inmediato por audio o video.",
      },
      {
        q: "¿El life coaching se cobra por mes?",
        a: "No. En Camyvera pagas por minuto según el tiempo que uses, lo que suele encajar mejor en llamadas de coaching cortas y enfocadas en decidir.",
      },
      {
        q: "¿Qué temas puedo llevar a un life coach?",
        a: "La gente suele usar las llamadas de life coaching para claridad, confianza, definir metas, hábitos, transiciones y tomar decisiones personales difíciles.",
      },
    ],
  },
  {
    slug: "business-advice",
    title: "Consejo de negocios en línea",
    seoTitle: "Consejo de negocios en línea | Llamadas al instante con coaches y operadores",
    description:
      "Recibe consejo de negocios en línea de mavens verificados en Camyvera. Analiza precios, crecimiento, contrataciones, GTM y decisiones de operador mediante llamadas pagadas al instante.",
    hero:
      "¿Necesitas un segundo cerebro para precios, crecimiento, contrataciones o ejecución? Habla con coaches de negocios y operadores en tiempo real en vez de esperar a una reunión futura.",
    keywords:
      "consejo de negocios en línea, llamada con coach de negocios, consejo de mentor de startups, consejo para founders en línea, consultoría de negocios por minuto",
    primaryLinks: [
      { href: "/talk-to-business-coach", label: "Habla con un coach de negocios" },
      { href: "/talk-to-startup-mentor", label: "Habla con un mentor de startups" },
      { href: "/blog/best-platforms-for-paid-calls", label: "Compara plataformas de llamadas pagadas" },
    ],
    faqs: [
      {
        q: "¿Qué tipo de consejo de negocios puedo obtener en línea?",
        a: "Los casos comunes incluyen precios, contrataciones, salida al mercado, decisiones de founder, adquisición de clientes y feedback de operadores.",
      },
      {
        q: "¿Por qué usar consultoría de negocios por minuto?",
        a: "Te permite obtener consejo puntual para una decisión específica sin comprometerte a un contrato grande ni a una consultoría completa.",
      },
      {
        q: "¿Puedo hablar con un mentor de startups y un coach de negocios en Camyvera?",
        a: "Sí. Camyvera admite tanto coaching de negocios general como mentoría específica de startups, según el perfil que elijas.",
      },
    ],
  },
  {
    slug: "career-advice",
    title: "Consejo de carrera en línea",
    seoTitle: "Consejo de carrera en línea | Habla con un coach de carrera rápido",
    description:
      "Recibe consejo de carrera en línea con llamadas al instante en Camyvera. Analiza entrevistas, ascensos, ofertas, negociación de salario y estrategia de búsqueda de empleo con un coach en vivo.",
    hero:
      "Cuando una entrevista, oferta o decisión de ascenso urge, un coach de carrera en vivo puede ayudarte a avanzar más rápido y con más confianza.",
    keywords:
      "consejo de carrera en línea, hablar con un coach de carrera, coaching de carrera al instante, coach de negociación de salario, coaching de entrevistas en línea",
    primaryLinks: [
      { href: "/talk-to-career-coach", label: "Habla con un coach de carrera" },
      { href: "/guides", label: "Explora las guías de Camyvera" },
      { href: "/blog/best-way-to-get-maven-advice-online", label: "Lee la guía de consejo 2026" },
    ],
    faqs: [
      {
        q: "¿Puedo usar Camyvera para coaching de entrevistas?",
        a: "Sí. Muchos seekers usan Camyvera para preparación de entrevistas en vivo, decisiones de búsqueda de empleo, negociación de salario y evaluación de ofertas.",
      },
      {
        q: "¿Qué tan rápido puedo hablar con un coach de carrera?",
        a: "Si un coach está en línea, normalmente puedes iniciar una llamada al instante en segundos, en vez de agendar con días de anticipación.",
      },
      {
        q: "¿Necesito comprar un paquete?",
        a: "No. Camyvera usa llamadas por minuto para que obtengas ayuda puntual sin comprar un paquete de coaching más grande.",
      },
    ],
  },
  {
    slug: "relationship-advice",
    title: "Consejo de relaciones en línea",
    seoTitle: "Consejo de relaciones en línea | Llamadas al instante con coaches de relaciones",
    description:
      "Recibe consejo de relaciones en línea en Camyvera con llamadas al instante con coaches verificados. Trabaja comunicación, límites, conflictos, citas y conversaciones difíciles.",
    hero:
      "A veces necesitas perspectiva antes del próximo mensaje, cita o conversación. Camyvera te ayuda a hablar con un coach de relaciones de inmediato.",
    keywords:
      "consejo de relaciones en línea, hablar con un coach de relaciones, coach de citas en línea, coaching de relaciones al instante, llamada de coaching para relaciones",
    primaryLinks: [
      { href: "/talk-to-relationship-coach", label: "Habla con un coach de relaciones" },
      { href: "/talk-to-dating-coach", label: "Habla con un coach de citas" },
      { href: "/pay-per-minute-consultation", label: "Por qué funciona pagar por minuto" },
    ],
    faqs: [
      {
        q: "¿Qué temas de relaciones encajan bien en el coaching al instante?",
        a: "La gente suele usar las llamadas de coaching de relaciones para conflictos, comunicación, límites, conversaciones difíciles y claridad sobre los próximos pasos.",
      },
      {
        q: "¿Puedo recibir ayuda antes de una conversación difícil?",
        a: "Sí. Ese es uno de los casos más fuertes para el consejo de relaciones al instante, porque el momento suele importar más que una cita futura.",
      },
      {
        q: "¿El consejo de citas es distinto del coaching de relaciones?",
        a: "Normalmente sí. El consejo de citas tiende a enfocarse en mensajes, citas y estrategia de apps, mientras que el coaching de relaciones se enfoca más en las dinámicas continuas y la comunicación.",
      },
    ],
  },
  {
    slug: "startup-advice",
    title: "Consejo de startups en línea",
    seoTitle: "Consejo de startups en línea | Mentoría al instante de founders y operadores",
    description:
      "Recibe consejo de startups en línea con llamadas en vivo con founders, operadores y mentores de startups en Camyvera. Analiza GTM, fundraising, precios y decisiones de contratación.",
    hero:
      "Los founders a menudo necesitan input agudo hoy, no el próximo mes. Usa Camyvera para consejo de startups en tiempo real de gente que ya pasó por ahí.",
    keywords:
      "consejo de startups en línea, llamada con mentor de startups, consejo para founders, consejo de GTM en línea, mentor de fundraising",
    primaryLinks: [
      { href: "/talk-to-startup-mentor", label: "Habla con un mentor de startups" },
      { href: "/video-consultation-platform", label: "Conoce la plataforma de consulta" },
      { href: "/blog/how-to-monetize-knowledge-as-coach", label: "Para Mavens: monetiza tu conocimiento" },
    ],
    faqs: [
      {
        q: "¿Qué decisiones de startup encajan bien en una llamada corta con un mentor?",
        a: "Los founders suelen usar llamadas cortas para precios, GTM, mensajes de fundraising, decisiones de contratación, posicionamiento y compensaciones de producto.",
      },
      {
        q: "¿Por qué usar consejo de startups al instante en vez de agendar un mentor más adelante?",
        a: "Porque muchas decisiones de founder son urgentes. El consejo al instante te ayuda a avanzar mientras el contexto sigue fresco.",
      },
      {
        q: "¿Puedo hablar con gente con experiencia de operador?",
        a: "Sí. Los perfiles de Camyvera pueden incluir operadores, founders, coaches y expertos de nicho con experiencia funcional específica.",
      },
    ],
  },
  {
    slug: "dating-advice",
    title: "Consejo de citas en línea",
    seoTitle: "Consejo de citas en línea | Llamadas al instante con coaches de citas",
    description:
      "Recibe consejo de citas en línea de coaches en vivo en Camyvera. Trabaja mensajes, primeras citas, confianza, apps de citas y toma de decisiones mediante llamadas al instante.",
    hero:
      "Recibe ayuda rápida y práctica con mensajes, primeras citas, confianza o estrategia de apps de citas mediante coaching en tiempo real en Camyvera.",
    keywords:
      "consejo de citas en línea, hablar con un coach de citas, consejo de citas al instante, llamada con coach de citas, consejo de relaciones en línea",
    primaryLinks: [
      { href: "/talk-to-dating-coach", label: "Habla con un coach de citas" },
      { href: "/relationship-advice", label: "Explora el consejo de relaciones" },
      { href: "/talk-to-experts-online", label: "Cómo funciona Camyvera" },
    ],
    faqs: [
      {
        q: "¿Puedo recibir ayuda con apps de citas y mensajes?",
        a: "Sí. El coaching de citas en Camyvera se usa comúnmente para decisiones de mensajes, estrategia de apps de citas, confianza y feedback de primeras citas.",
      },
      {
        q: "¿Necesito un paquete de coaching largo para recibir consejo de citas?",
        a: "No. Camyvera está diseñada para llamadas cortas, puntuales y por minuto cuando necesitas perspectiva rápido.",
      },
      {
        q: "¿Qué tan rápido puedo conectarme con un coach de citas?",
        a: "Si un coach está en línea en ese momento, normalmente puedes conectarte de inmediato sin esperar a una sesión agendada.",
      },
    ],
  },
];

export const ADVICE_CATEGORY_ROUTE_MAP_ES = ADVICE_CATEGORIES_ES.map((category) => ({
  path: `/${category.slug}`,
  changefreq: "weekly",
  priority: 0.85,
}));
